import { useReducer, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";

import {
  formatDate,
  formatDateTime,
  // getCaseId,
  // getClientId,
  getLoggedInUserId,
} from "../../../Utils/helper";
import { api_without_cancellation } from "../../../api/api";
import UserChatBubble from "../../Forms/FirmUserBtn";
import avatarImage from "../../../assets/images/avatar.svg";

const ClientTab = ({ data, _refetchDrafts, onOpenWordProcessor }) => {
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const tableRef = useRef(null);
  // const { footerState, _setFooterState } = useFooter();
  // Footer tabs will be removed
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const initialState = {
    show: false,
    status: "",
  };
  const _userId = getLoggedInUserId();

  function reducer(state, action) {
    switch (action.type) {
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };

      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  const _checkDraftLock = async (draftId) => {
    try {
      const response = await api_without_cancellation.post(
        `${origin}/api/documents/check-draft-lock/`,
        { draft_id: draftId }
      );
      return response.data;
    } catch (error) {
      console.error("Error checking draft lock:", error);
      return { error: true };
    }
  };

  const _createEditDoc = async (docId, url, name, dynamic_template_id) => {
    try {
      const _currentUrl = window.location.href;

      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", url);
      formData.append("name", name);
      formData.append("template_id", dynamic_template_id);

      const _response = await api_without_cancellation.post(
        `${origin}/api/create-edit-doc/`,
        formData
      );

      // Proceed with additional logic if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleEditButton = async (draft) => {
    // Check draft lock status via API
    // const lockStatus = await checkDraftLock(draft.id);

    // if (lockStatus.error) {
    //   dispatch({
    //     type: "SHOW_MODAL",
    //     payload: "Unable to check draft status. Please try again.",
    //   });
    //   return;
    // }

    // // If locked by someone else (not current user), show modal
    // if (lockStatus.is_locked) {
    //   dispatch({
    //     type: "SHOW_MODAL",
    //     payload: `This draft is currently being edited by ${lockStatus.locked_by.first_name} ${lockStatus.locked_by.last_name}. It will be available when they close the document.`,
    //   });

    //   if (!draft.locked_by) {
    //     refetchDrafts(false);
    //   }
    //   return;
    // }

    // Call parent callback to open word processor in tab
    onOpenWordProcessor(draft);
  };

  // const [availableRows, setAvailableRows] = useState(0);

  // useLayoutEffect(() => {
  //   if (!tableRef.current && !data) return;

  //   const totalHeight = tableRef.current.getBoundingClientRect().height;
  //   console.log(totalHeight);
  //   const height = totalHeight - 25;
  //   const rowsFromHeight = Math.floor(height / 35);
  //   const rowsToSubtract = data?.length ?? 0;

  //   setAvailableRows(Math.max(0, rowsFromHeight - rowsToSubtract));
  // }, [data]);

  return (
    <>
      <div
        className="m-b-5 table--no-card rounded-0 border-0 w-100"
        style={{
          height: "305px",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
        ref={tableRef}
      >
        <table className="table table-borderless table-striped table-earning settlement-table">
          <thead>
            <tr id="settle-tb-header" className="settle-t-4 cursor-default">
              <th
                className=""
                style={{
                  width: "25px",
                  minWidth: "25px",
                  maxWidth: "25px",
                }}
              />
              <th className="text-center td-autosize">Client Name</th>
              <th className="" />
              <th className="text-center td-autosize">Draft Name</th>
              <th className="" />
              <th className="text-center td-autosize">Category</th>
              <th className="" />
              <th className="text-center td-autosize" colSpan={2}>
                Edited By
              </th>
              <th className="" />

              {/* <th className="text-center td-autosize">Edit By</th> */}
              {/* <th className="" /> */}
              <th className="text-center td-autosize">Last Activity</th>
              <th className="" />
              <th className="text-center td-autosize">Litigation Act</th>
              <th className="" />
              <th className="text-center td-autosize">Action</th>
              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1">
            {data?.map((draft, idx) => {
              return (
                <>
                  <tr key={draft?.id} className="cursor-default">
                    <td className="text-center" style={{ width: "25px" }}>
                      {idx + 1}
                    </td>
                    <td className="td-autosize">
                      <div
                        className="d-flex align-items-center height-21"
                        style={{
                          gap: "5px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        <span className="ic-avatar ic-15 has-avatar-icon has-cover-img">
                          <img
                            className="output-18 theme-ring"
                            src={
                              draft?.for_client_profile?.avatar
                                ? draft?.for_client_profile?.avatar
                                : avatarImage
                            }
                            style={{
                              background: "var(--primary-30)",
                            }}
                          />
                        </span>
                        <p className="">
                          {draft?.for_client_profile?.first_name}{" "}
                          {draft?.for_client_profile?.last_name}
                        </p>
                      </div>
                    </td>
                    <td />
                    <td className="td-autosize">{draft?.document_name}</td>
                    <td />
                    <td className="td-autosize">
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="ic ic-15 d-flex align-items-center justify-content-center">
                          <img src={draft?.for_template?.for_page?.page_icon} />
                        </span>
                        <span className="p-l-5">{draft?.for_template?.for_page?.name}</span>
                      </div>
                    </td>
                    <td />
                    <td className="td-autosize text-end">{`${formatDate(draft?.created_at)}${draft?.locked_by ? ":" : ""}`}</td>
                    <td className="td-autosize text-start">
                      {draft?.locked_by && (
                        <span className="d-flex justify-content-center">
                          <UserChatBubble
                            userId={draft?.locked_by?.id}
                            first_name={draft?.locked_by?.first_name}
                            last_name={draft?.locked_by?.last_name}
                            profilePic={draft?.locked_by?.avatar_url ?? ""}
                            is_active={draft?.locked_by?.is_active}
                            width={19}
                            height={25}
                            isActive={userOnlineStatus?.[draft?.locked_by?.id]?.isOnline ?? false}
                          />
                        </span>
                      )}
                    </td>
                    <td />

                    {/* <td /> */}
                    <td className="td-autosize">
                      {draft?.last_activity && formatDateTime(draft.last_activity)}
                    </td>
                    <td />
                    {/* Litigation Act */}
                    <td />
                    <td />
                    <td>
                      <div className="d-flex justify-content-center space-x-5">
                        <Button
                          // variant={
                          //   draft?.locked_by && draft?.locked_by?.id !== Number(userId)
                          //     ? "secondary"
                          //     : "primary"
                          // }
                          // disabled={draft.locked_by && draft?.locked_by?.id !== Number(userId)}
                          className="height-20 d-flex align-items-center justify-content-center"
                          onClick={() => handleEditButton(draft)}
                        >
                          <span>Edit</span>
                          <span>
                            <i className="ic ic-15 edit-template-icon ms-1" />
                          </span>
                        </Button>
                      </div>
                    </td>
                    <td />
                  </tr>
                </>
              );
            })}
            {[...Array(Math.max(8 - (data?.length || 0), 0))].map((_, index) => (
              <tr key={`fake-row-${index}`} className="fake-row-2" style={{ height: "35px" }}>
                <td colSpan="16">&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        <Modal show={state.show} onHide={() => dispatch({ type: "HIDE_MODAL" })}>
          <Modal.Header>
            <Modal.Title
              dangerouslySetInnerHTML={{ __html: state.status }}
              className="modal-title h4 justify-content-center text-center"
            />
          </Modal.Header>
          <Modal.Footer style={{ borderTop: "none" }}>
            <Button
              variant="secondary"
              className="mx-auto"
              onClick={() => dispatch({ type: "HIDE_MODAL" })}
            >
              Dismiss
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

export default ClientTab;
